// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      "--theme-color": "white",
      "--theme-high-contrast-color": "var(--lightgrey)",
      "--theme-foreground-color": "black",
      "--theme-low-contrast-foreground-color": "var(--grey)",
    },
    name: "default",
    label: "Default",
  },
  {
    style: {
      "--theme-color": "var(--lightgrey)",
      "--theme-high-contrast-color": "var(--charcoal)",
      "--theme-foreground-color": "var(--charcoal)",
      "--theme-low-contrast-foreground-color": "var(--lightgrey)",
    },
    name: "lightgrey",
    label: "Light Grey",
  },
  {
    style: {
      "--theme-color": "var(--coral)",
      "--theme-high-contrast-color": "white",
      "--theme-foreground-color": "white",
      "--theme-low-contrast-foreground-color": "var(--darkcoral)",
    },
    name: "coral",
    label: "Coral",
  },
];

export default blockThemes;
